import {PortExposureBodyChunk} from "../../chunks/types/PortExposureBodyChunk";
import {getNameFromIdentifierChunk} from "./getNameFromIdentifier";

export function getOwnPortNameFromPortExposureBodyChunk(
  portExposureBodyChunk: PortExposureBodyChunk
): string {
  const {
    captures: {
      2: ownPortNameChunk
    }
  } = portExposureBodyChunk;
  return getNameFromIdentifierChunk(ownPortNameChunk);
}
